module.exports = __webpack_public_path__ + "static/key-battlestar-7806276bf211a153bd836ae583ac6125.webp";